
/**
 * Sales Running Timer
 */
const salesRunningTimer = function () {
	let $dealsEndDateAndTimeContainer = $('.dealsEndDateAndTimeContainer');

	if ($dealsEndDateAndTimeContainer.length > 0) {
		let $dealsEndDateAndTime = $('.dealsEndDateAndTime');

		if ($dealsEndDateAndTime.length > 0) {
			$dealsEndDateAndTime.each(function () {
				let $self = $(this),
					$container = $self.closest('.dealsEndDateAndTimeContainer'),
					$selectorEl = $container.find('.timerunnercontainer');

				let timerId;

				function countdownTimer() {
					let difference = +new Date($self.text()) - +new Date(),
						remaining = null;

					if (difference > 0) {
						let parts = {
							d: Math.floor(difference / (1000 * 60 * 60 * 24)),
							h: Math.floor(difference / (1000 * 60 * 60) % 24),
							m: Math.floor(difference / 1000 / 60 % 60),
							s: Math.floor(difference / 1000 % 60)
						};
						remaining = Object.keys(parts).map(function (part) {
							if (!parts[part]) {
								return;
							}

							return ''.concat(parts[part]).concat(part);
						}).join(' ');
					}

					if (remaining) {
						$selectorEl.css('color', '#ff0000');
						$selectorEl.attr('data-timer', remaining);

						if (remaining.includes('d')) {
							if (parseInt(remaining.replace('d', '')) <= 10) {
								let prefix = $self.hasClass('couponTimer') ? 'Offer ends in' : 'Sale ends in';

								if ($self.hasClass('couponTimer')) {
									$selectorEl.removeClass('text-muted').addClass('text-danger custom-font-weight-600');
								}
								$selectorEl.html(prefix + ' <b> ' + remaining + '</b>');
							} else if ($self.hasClass('couponTimer')) {
								let expirationText = $self.text().trim().split(' ')[0];

								$selectorEl.css('color', '').html('Expires ' + expirationText);
							}
						}
					} else {
						clearInterval(timerId);
						$container.addClass('d-none');
					}
				}

				countdownTimer();
				timerId = setInterval(countdownTimer, 1000);
			});
		}
	}
};

export default salesRunningTimer;
